<script lang="ts" setup>
import { useCategoryCollectionRecs } from '~/composables/Learn/useCategoryCollectionRecs';
import { useCoinsPerDollarCopy } from '~/composables/Learn/useCoinsPerDollarCopy';
import { useSignupLink } from '~/composables/unified/useSignupLink';
import { UNIFIED_ROUTE_LEARN_COLLECTION } from '~/constants/routes/unified';
import { CollectionCategory } from '~/graphql/generated/graphql';
import { ENTRY_CTA, ENTRY_SOURCE } from '~/utils/unified/entryTracking';

const { t } = useI18n();

const { buildLink } = useSignupLink();
const loginLink = computed(() => buildLink({ entrySource: ENTRY_SOURCE.ROOT_UNIFIED, entryCta: ENTRY_CTA.VIRTUAL_CAREER }));
const handleCardClick = (slug: string) => navigateTo(UNIFIED_ROUTE_LEARN_COLLECTION(slug));

const trendingRecs = useCategoryCollectionRecs({ category: CollectionCategory.Trending }).recs;
const coinsPerDollar = useCoinsPerDollarCopy();
</script>

<template>
  <div class="py-16 max-w-6xl mx-auto">
    <KUIUnifiedLearnLandingTrendingSection
      :recs="trendingRecs"
      :cta-to="loginLink"
      :heading="t('unified.landing.virtualCareer.heading')"
      :description="t('unified.landing.virtualCareer.description')"
      :cta-text="t('unified.landing.virtualCareer.cta')"
      cta-variant="outline"
      :extra-text="coinsPerDollar"
      @card-click="handleCardClick"
    />
  </div>
</template>
